import { useEffect, useState } from "react";
import { Loader2, Trash2, CalendarDays } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { EmptyState } from "./Common";
import { ConfirmButton } from "./ConfirmButton";
import { api, dateLabel } from "../lib/api";

function useReviewImage(id) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u;
    api.get(`/reviews/${id}/image`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setUrl(""));
    return () => u && URL.revokeObjectURL(u);
  }, [id]);
  return url;
}

function ReviewCard({ r, showDriver, onOpen, onDelete, i, isNew }) {
  const url = useReviewImage(r.id);
  return (
    <div className={`rise relative rounded-2xl border bg-white overflow-hidden group ${isNew ? "border-pink-300 ring-2 ring-pink-200" : "border-slate-200"}`} style={{ animationDelay: `${i * 40}ms` }} data-testid={`review-card-${r.id}`}>
      {isNew && <span className="absolute top-2 left-2 z-10 rounded-full bg-pink-500 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white shadow" data-testid={`review-new-${r.id}`}>Baru</span>}
      <button onClick={() => url && onOpen({ ...r, url })} className="block w-full aspect-[4/5] bg-slate-100 overflow-hidden" data-testid={`review-open-${r.id}`}>
        {url ? <img src={url} alt="Review tamu" className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" /> : (
          <div className="h-full grid place-items-center">{url === "" ? <span className="text-xs text-slate-400">Gagal memuat</span> : <Loader2 className="h-5 w-5 animate-spin text-slate-400" />}</div>
        )}
      </button>
      <div className="p-3">
        <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-900"><CalendarDays className="h-3.5 w-3.5 text-emerald-600" />{dateLabel(r.tour_date)}</p>
        {showDriver && <p className="text-xs text-slate-600 mt-0.5">{r.driver_name}</p>}
        {r.tour_name && <p className="text-xs text-slate-500 truncate">{r.tour_name}</p>}
        {onDelete && (
          <ConfirmButton title="Hapus review?" description="Screenshot review ini akan dihapus." onConfirm={() => onDelete(r)} testId={`delete-review-${r.id}`} confirmLabel="Hapus">
            <button className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-red-600 hover:underline min-h-[32px]" data-testid={`delete-review-${r.id}`}><Trash2 className="h-3.5 w-3.5" />Hapus</button>
          </ConfirmButton>
        )}
      </div>
    </div>
  );
}

export function ReviewGallery({ reviews, showDriver, onDelete, seenAt }) {
  const [open, setOpen] = useState(null);
  if (!reviews.length) return <EmptyState title="Belum ada review" text="Screenshot review tamu dari admin akan tampil di sini." testId="empty-reviews" />;
  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4" data-testid="review-gallery">
        {reviews.map((r, i) => <ReviewCard key={r.id} r={r} i={i} showDriver={showDriver} onOpen={setOpen} onDelete={onDelete} isNew={seenAt !== undefined && r.created_at > seenAt} />)}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto" data-testid="review-dialog">
          <DialogTitle className="font-heading">Review Tamu · {open && dateLabel(open.tour_date)}</DialogTitle>
          <DialogDescription>{open?.driver_name}{open?.tour_name && ` · ${open.tour_name}`}{open?.note && ` · ${open.note}`}</DialogDescription>
          {open && <img src={open.url} alt="Review tamu" className="w-full rounded-lg border object-contain max-h-[70vh]" data-testid="review-dialog-image" />}
        </DialogContent>
      </Dialog>
    </>
  );
}
